/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress } from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import {
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSONTyped,
    ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON,
} from './ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress';
import type { ExecRiskUSAddress } from './ExecRiskUSAddress';
import {
    ExecRiskUSAddressFromJSON,
    ExecRiskUSAddressFromJSONTyped,
    ExecRiskUSAddressToJSON,
} from './ExecRiskUSAddress';

/**
 * 
 * @export
 * @interface ExecRiskContractorAddress
 */
export interface ExecRiskContractorAddress {
    /**
     * 
     * @type {ExecRiskUSAddress}
     * @memberof ExecRiskContractorAddress
     */
    USAddress?: ExecRiskUSAddress;
    /**
     * 
     * @type {ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress}
     * @memberof ExecRiskContractorAddress
     */
    ForeignAddress?: ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddress;
}

/**
 * Check if a given object implements the ExecRiskContractorAddress interface.
 */
export function instanceOfExecRiskContractorAddress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskContractorAddressFromJSON(json: any): ExecRiskContractorAddress {
    return ExecRiskContractorAddressFromJSONTyped(json, false);
}

export function ExecRiskContractorAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskContractorAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'USAddress': !exists(json, 'USAddress') ? undefined : ExecRiskUSAddressFromJSON(json['USAddress']),
        'ForeignAddress': !exists(json, 'ForeignAddress') ? undefined : ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressFromJSON(json['ForeignAddress']),
    };
}

export function ExecRiskContractorAddressToJSON(value?: ExecRiskContractorAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'USAddress': ExecRiskUSAddressToJSON(value.USAddress),
        'ForeignAddress': ExecRiskApiAppApiV1EagerTasksForm990ModelsCommonTypesForeignAddressToJSON(value.ForeignAddress),
    };
}

